// src/api/auth.js
import axios from "axios";

// const BASE_URL = 'https://anjangoldbackend.onrender.com/api';
// const BASE_URL = "http://localhost:5000/api";
// const BASE_URL = "http://192.168.29.200:5000/api";
// const BASE_URL = "http://3.110.92.249:5000/api";
const BASE_URL = "https://api.anjalgold.com/api";

// Create axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      const token = parsed.token; // token already includes 'Bearer'

      if (token) {
        config.headers.Authorization = token; // Already includes 'Bearer'
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
